<template>
  <div class="input-search">
    <input :id="id" type="text" :value="value" class="input-text" :placeholder="placeholder" @input="onInput" />

    <Transition name="input-search__clear" appear>
      <RouterLink v-if="value.length" :to="clearSearchRoute" class="input-search__clear" replace>
        <SvgIcon id="close" />
      </RouterLink>
    </Transition>
  </div>
</template>

<script>
import { debounce } from 'lodash-es'

export default {
  name: 'InputSearchQuery',
  props: {
    id: { type: String, required: true },
    placeholder: String
  },
  data() {
    return {
      updateQuery: () => {}
    }
  },
  computed: {
    value() {
      return this.$route.query.search || ''
    },
    clearSearchRoute() {
      const { page, search, ...query } = this.$route.query
      return { query }
    }
  },
  created() {
    this.updateQuery = debounce(query => {
      this.$router.replace({ query })
    }, 500)
  },
  methods: {
    onInput({ target }) {
      const { page, search, ...restQuery } = this.$route.query
      const normalizedValue = target.value
      if (normalizedValue === this.value) return

      const query = normalizedValue ? { ...restQuery, search: normalizedValue } : restQuery
      this.updateQuery(query)
    }
  }
}
</script>
